import { Routes } from '@angular/router';
import { environment } from '../environments/environment';
import { APP_TITLE } from './authentication/models/global.variables';
import { LoginGuard } from './guards/login.guard';
import { subscriptionGuard } from './guards/subscription.guard';

export const routes: Routes = [
  ...resolveAuthPaths(),
  {
    path: 'print-invoice/:id',
    loadComponent: () =>
      import('./features/invoices/pages/print-invoice-page/print-invoice-page.component').then(
        (c) => c.PrintInvoicePageComponent,
      ),
    canActivate: [LoginGuard],
    title: 'Print Invoice : ' + APP_TITLE,
  },
  {
    path: 'print-record/:id',
    loadComponent: () =>
      import('./features/customers/pages/print-record-page/print-record-page.component').then(
        (c) => c.PrintRecordPageComponent,
      ),
    canActivate: [LoginGuard],
    title: 'Client Record : ' + APP_TITLE,
  },
  {
    path: '',
    loadChildren: () =>
      import('./features/features.routes').then((r) => r.featureRoutes),
    canActivate: [LoginGuard, subscriptionGuard],
  },
  {
    path: 'portal',
    loadChildren: () =>
      import('./public-portal/portal.routes').then((r) => r.routes),
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('./settings/settings.routes').then((r) => r.routes),
    title: 'Settings : ' + APP_TITLE,
  },
  {
    path: 'pricing',
    loadComponent: () =>
      import('./features/subscription/pages/pricing/pricing.component').then(
        (m) => m.PricingComponent,
      ),
    title: 'Pricing : ' + APP_TITLE,
  },
  {
    path: ':shortKey',
    loadComponent: () =>
      import('./public-portal/short-link/short-link.component').then(
        (c) => c.ShortLinkComponent,
      ),
  },
  {
    path: '**',
    redirectTo: 'login',
  },
];

function resolveAuthPaths(): any[] {
  let clientCode = environment.clientCode;

  if (clientCode === 'buky')
    return [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      },
      {
        path: '',
        children: [
          {
            path: 'login',
            loadComponent: () =>
              import('./authentication/pages/login/login.component').then(
                (c) => c.LoginComponent,
              ),
            title: 'Login: ' + APP_TITLE,
          },
          {
            path: 'signup',
            loadComponent: () =>
              import('./authentication/pages/register/register.component').then(
                (c) => c.RegisterComponent,
              ),
            title: 'Signup: ' + APP_TITLE,
          },
          {
            path: 'verify/:token/:userId',
            loadComponent: () =>
              import(
                './authentication/pages/verify-email/verify-email.component'
              ).then((c) => c.VerifyEmailComponent),
            title: 'Account verification : ' + APP_TITLE,
          },
          {
            path: 'start-reset-password',
            loadComponent: () =>
              import(
                './authentication/pages/inititate-reset-password/inititate-reset-password.component'
              ).then((c) => c.InititateResetPasswordComponent),
            title: 'Reset password: ' + APP_TITLE,
          },
          {
            path: 'resetPassword/:token/:email',
            loadComponent: () =>
              import(
                './authentication/pages/reset-password/reset-password.component'
              ).then((c) => c.ResetPasswordComponent),
            title: 'Reset password: ' + APP_TITLE,
          },
          {
            path: 'accept-invite-register/:token',
            loadComponent: () =>
              import(
                './authentication/pages/accept-invite-register/accept-invite-register.component'
              ).then((c) => c.AcceptInviteRegisterComponent),
            title: 'Register : ' + APP_TITLE,
          },
          {
            path: 'accept-invite/:token',
            loadComponent: () =>
              import(
                './authentication/pages/accept-invite/accept-invite.component'
              ).then((c) => c.AcceptInviteComponent),
            title: 'Invitation : ' + APP_TITLE,
          },
        ],
      },
      {
        path: 'accounts',
        loadChildren: () =>
          import('./features/accounts/account.routes').then(
            (r) => r.accountRoutes,
          ),
        title: 'Accounts : ' + APP_TITLE,
      },
    ];

  return [];
}
